export default __webpack_public_path__ + "static/media/rgt-img-2.711272db.jpg";